module.exports = __webpack_public_path__ + "static/media/arrows-explore.45a7d07f.svg";